import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";

export const getMCPTools = async (token) => {
  try {
    const response = await apiFetch(`${backUrl}/mcp-tools`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching MCP tools:", error);
    throw error;
  }
};

export const getMCPToolById = async (token, toolId) => {
  try {
    const response = await apiFetch(`${backUrl}/mcp-tools/${toolId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching MCP tool:", error);
    throw error;
  }
};

export const createMCPTool = async (token, toolData) => {
  try {
    const response = await apiFetch(`${backUrl}/mcp-tools`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(toolData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating MCP tool:", error);
    throw error;
  }
};

export const updateMCPTool = async (token, toolId, updateData) => {
  try {
    const response = await apiFetch(`${backUrl}/mcp-tools/${toolId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating MCP tool:", error);
    throw error;
  }
};

export const deleteMCPTool = async (token, toolId) => {
  try {
    const response = await apiFetch(`${backUrl}/mcp-tools/${toolId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting MCP tool:", error);
    throw error;
  }
};

